import { TreeNode } from "react-dropdown-tree-select";

export const filterDishesTreeBySearch = (nodes: TreeNode[], search: string): TreeNode[] => {
    const term = search.trim().toLowerCase();
    if (!term) return nodes;

    const filterNode = (node: TreeNode): TreeNode | null => {
        const label = String(node.label ?? "").toLowerCase();
        const matches = label.includes(term);

        const children: TreeNode[] = node.children
            ? node.children.map(filterNode).filter((child: TreeNode | null): child is TreeNode => child !== null)
            : [];

        if (matches || children.length) {
            return {
                ...node,
                children,
                ...(children.length ? { expanded: true } : {}),
            };
        }

        return null;
    };

    return nodes.map(filterNode).filter((node): node is TreeNode => node !== null);
};
